import { Template } from "meteor/templating";
import { Tracker } from "meteor/tracker";

import "./banana_progress_gauge_lecture.html";
import "../core/banana_progress_gauge_core.css";
import "./banana_progress_gauge_lecture.css";

import {
  BANANA_PROGRESS_GAUGE_VIEWBOX_DEFAULT,
  apply_imported_svg_layer_styles,
  banana_progress_clip_points,
  banana_progress_clip_width,
  boundary_options_from_data,
  format_svg_number,
  format_viewbox,
  good_answers_from_data,
  inject_source_svg,
  layer_colors_from_data,
  layer_style_from_data,
  progress_from_data,
  selected_layer_class_from_data,
  source_text_from_data,
  source_url_from_data,
  source_viewbox_from_data,
  total_from_data,
} from "../core/banana_progress_gauge_core.js";

export { normalise_banana_progress_gauge_config } from "../core/banana_progress_gauge_core.js";

let bananaProgressGaugeUid = 0;

Template.bananaProgressGauge.onCreated (function ()
  {
    bananaProgressGaugeUid += 1;
    this.bananaProgressGaugeClipId = `banana-progress-gauge-clip-${bananaProgressGaugeUid}`;
  });

Template.bananaProgressGauge.onRendered (function ()
  {
    const tpl = this;
    tpl.autorun (() =>
      {
        source_text_from_data (Template.currentData ());
        Tracker.afterFlush (() => { inject_source_svg (tpl); });
      });
    tpl.autorun (() =>
      {
        const tData = Template.currentData ();
        progress_from_data (tData);
        layer_colors_from_data (tData);
        if (tData) tData.selectedColorLayer;
        Tracker.afterFlush (() => { apply_imported_svg_layer_styles (tpl, tData); });
      });
  });

Template.bananaProgressGauge.helpers (
  {
    bananaProgressGaugeClass ()
      {
        return (this && this.className) || "";
      },

    bananaProgressGaugeClipId ()
      {
        return Template.instance ().bananaProgressGaugeClipId;
      },

    bananaProgressGaugeClipWidth ()
      {
        return banana_progress_clip_width (progress_from_data (this));
      },

    bananaProgressGaugeClipPoints ()
      {
        return banana_progress_clip_points (
          progress_from_data (this),
          "trace",
          boundary_options_from_data (this)
        );
      },

    bananaProgressGaugeViewBox ()
      {
        return this && this.viewBox
          ? format_viewbox (this.viewBox)
          : format_viewbox ((source_text_from_data (this) || source_url_from_data (this)) ? source_viewbox_from_data (this) : BANANA_PROGRESS_GAUGE_VIEWBOX_DEFAULT);
      },

    bananaProgressGaugeSourceUrl ()
      {
        return source_url_from_data (this);
      },

    bananaProgressGaugeSourceText ()
      {
        return source_text_from_data (this);
      },

    bananaProgressGaugeImageX ()
      {
        return format_svg_number (source_viewbox_from_data (this).x);
      },

    bananaProgressGaugeImageY ()
      {
        return format_svg_number (source_viewbox_from_data (this).y);
      },

    bananaProgressGaugeImageWidth ()
      {
        return format_svg_number (source_viewbox_from_data (this).w);
      },

    bananaProgressGaugeImageHeight ()
      {
        return format_svg_number (source_viewbox_from_data (this).h);
      },

    bananaProgressGaugePreserveAspectRatio ()
      {
        return (this && this.preserveAspectRatio) || "xMidYMid meet";
      },

    bananaProgressGaugeLayerStyle (pLayerId, pPhase)
      {
        return layer_style_from_data (this, pLayerId, pPhase);
      },

    bananaProgressGaugeLayerSelectedClass (pLayerId)
      {
        return selected_layer_class_from_data (this, pLayerId);
      },

    bananaProgressGaugeTotal ()
      {
        return total_from_data (this);
      },

    bananaProgressGaugeGoodAnswers ()
      {
        return good_answers_from_data (this);
      },

    bananaProgressGaugeLabel ()
      {
        const tGood = good_answers_from_data (this);
        const tTotal = total_from_data (this);
        if (this && this.label) return this.label;
        return `${tGood} bonne${tGood > 1 ? "s" : ""} réponse${tGood > 1 ? "s" : ""} sur ${tTotal}`;
      },
  });
